import { render, staticRenderFns } from "./SendLicense.vue?vue&type=template&id=105c27d2&scoped=true&"
import script from "./SendLicense.vue?vue&type=script&lang=js&"
export * from "./SendLicense.vue?vue&type=script&lang=js&"
import style0 from "./SendLicense.vue?vue&type=style&index=0&id=105c27d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105c27d2",
  null
  
)

export default component.exports